import { DataSourceType} from '../types'
import { NewzooToDatabrain } from '@intelligence/utils/constant';

export const dataSource: DataSourceType[] = [
  // {
  //   id: 1,
  //   metrics: ['Revenue', 'Units'] ,
  //   source: 'GSD',
  //   icon: '',
  //   credibility: 5,
  //   info: [
  //     {
  //       title_zh: '1.来自头部发行商分享的第一手端游销售数据',
  //       title_en: '1.First-hand sales data shared from top publishers.'
  //     },
  //     {
  //       title_zh: '2.数据覆盖欧洲多地及日本市场',
  //       title_en: '2.Available territories includes European countries and Japan.'
  //     }
  //   ],
  //   url: '/intelligence/sourcesMetrics/metrics'
  // },
  {
    id: 2,
    metrics: ['Revenue', 'Downloads', 'Active Users'],
    combineMetrics: ['Revenue', 'Downloads', 'DAU', 'WAU', 'MAU'],
    source: 'data.ai',
    icon: 'appannie',
    credibility: 4,
    info: [
      {
        title_zh: '1.最权威的手游数据商',
        title_en: '1.The most authoritative data vendor of mobile games.'
      },
      {
        title_zh: '2.超百万app及众多消费者面板、广告的整合数据',
        title_en: '2.Anonymized and aggregated data from over 1 million apps, sizable consumer panels, top ad networks, and more.'
      }
    ],
    url: '/intelligence/sourcesMetrics/metrics'
  },
  {
    id: 3,
    metrics: ['Revenue', 'Downloads', 'Active Users'],
    combineMetrics: ['Revenue', 'Downloads', 'DAU', 'WAU', 'MAU'],
    source: 'Sensor Tower',
    credibility: 3.5,
    icon: 'sensortower',
    info: [
      {
        title_zh: '1.较为权威的手游数据商',
        title_en: '1.Authoritative data vendor of mobile games.'
      },
      {
        title_zh: '2.东南亚数据经社媒公开的切片数据进行校准',
        title_en: '2.The data for Southeast Asia markets is calibrated by real data fragments disclosed on social media publically.'
      }
    ],
    url: '/intelligence/sourcesMetrics/metrics'
  },
  {
    id: 10,
    metrics: ['Revenue','Units'],
    combineMetrics: [],
    source: 'GSD',
    credibility: 5,
    icon: 'gsd',
    info: [
      {
        title_zh: '1.来自头部发行商分享的第一手端游销售数据',
        title_en: '1.First-hand sales data shared from top publishers.'
      },
      {
        title_zh: '2.数据覆盖欧洲多地及日本市场',
        title_en: '2.Available territories includes European countries and Japan.'
      }
    ],
    url: '/intelligence/sourcesMetrics/metrics'
  },
  {
    id: 5,
    metrics: ['Digital Revenue', 'Digital Units'],
    source: 'Mscience',
    icon: 'mscience',
    credibility: 4.5,
    info: [
      {
        title_zh: '1.元数据来自线上电子小票，超4百万的用户面板规模',
        title_en: '1.Raw data collected from e-receipts with a panel size over 4 millions users made transactions.'
      },
      {
        title_zh: '2.经真实切片数据验证，美国区销售数据约占全球的50%',
        title_en: '2.US revenue accounts for 50% of global revenue approximately.'
      }
    ],
    url: '/intelligence/sourcesMetrics/metrics'
  },
  {
    id: 9,
    metrics: ['Steam Store Ranks'],
    combineMetrics: ['Top Sellers', 'Top Wish Lists'],
    source: 'Steam',
    icon: 'steam',
    credibility: 4.5,
    info: [
      {
        title_zh: '1.来自steam官网数据',
        title_en: '1.Data from steam official website.'
      },
      {
        title_zh: '2.数据分国家，通过ip代理方案拉取头部1000+游戏',
        title_en: '2.Data is divided by countries and over 1000 games per market with the IP analysis solution.'
      }
    ],
    url: '/intelligence/sourcesMetrics/metrics'
  },
  {
    id: 6,
    metrics: ['Physical Revenue'],
    source: 'NPD',
    icon: 'npd',
    credibility: 4,
    info: [
      {
        title_zh: '1.北美权威零售数据商',
        title_en: '1.Authoritative vendor of retail sales data.'
      },
      {
        title_zh: '2.数据可分游戏设备，包含第八、九世代主机游戏数据',
        title_en: '2.data by game devices, historical data of 8th & 9th Gen games.'
      }
    ],
    url: '/intelligence/sourcesMetrics/metrics'
  },
  {
    id: 4,
    metrics: ['PCU', 'ACU'],
    combineMetrics: ['Steam PCU', 'Steam ACU'],
    source: 'VG Insights',
    credibility: 4,
    icon: 'vginsights',
    info: [
      {
        title_zh: '1.数据来自数据商与Steam合作的API接口',
        title_en: '1.Data is provided by the vendor through Steam API.'
      },
      {
        title_zh: '2.PCU历史数据回溯至2014年',
        title_en: '2.PCU historical data goes back to 2014.'
      }
    ],
    url: '/intelligence/sourcesMetrics/metrics'
  },
  {
    id: 7,
    metrics: ['Steam Units'],
    source: 'VG Insights',
    icon: 'vginsights',
    credibility: 4,
    info: [
      {
        title_zh: '1.基于steam评论数的游戏本体销量预估',
        title_en: '1.Sales units estimate based on the number of steam reviews.'
      },
      {
        title_zh: '2.以部分真实数据及steam畅销榜排名做数据调整',
        title_en: '2.Data adjustment based on proprietary data of actual units sold and steam top selling lists.'
      }
    ],
    url: '/intelligence/sourcesMetrics/metrics'
  },
  {
    id: 8,
    metrics: ['MAU'],
    source: NewzooToDatabrain,
    icon: 'newzoo',
    credibility: 3,
    info: [
      {
        title_zh: '全球范围内用户调研数据',
        title_en: 'Survey and research data on a global scale.'
      }
    ],
    url: '/intelligence/sourcesMetrics/metrics'
  }
]